import React from "react";

import AddIcon from "@mui/icons-material/Add";

import Text from "@src/sharedComponents/Typography/Text";

import styles from "./CreateCustomAssetClassDropdownOption.module.css";

interface Props {
  setShowSearchInputDropdown: (show: boolean) => void;
  setShowCreateAssetClassModal: (show: boolean) => void;
}

const CreateCustomAssetClassDropdownOption: React.FC<Props> = ({
  setShowSearchInputDropdown,
  setShowCreateAssetClassModal,
}) => {
  return (
    <div
      className={styles.createAssetClassDropdownOption}
      onClick={() => {
        setShowSearchInputDropdown(false);
        setShowCreateAssetClassModal(true);
      }}
    >
      <AddIcon className={styles.createAssetClassDropdownOptionAddIcon} />

      <Text variant="body" color="text">
        Create asset class
      </Text>
    </div>
  );
};

export default CreateCustomAssetClassDropdownOption;
